/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".maps-panel[_ngcontent-%COMP%]{background-color:var(--background-color,inherit)}"];
export { styles as styles };
